import * as React from 'react';

interface Props {
  loadingText?: string;
}

export const LoadingView: React.SFC<Props> = (props) => {
  return (
    <div className="loading-spinner">
      <div className="text-center">
        <div className="mb-2">{props.loadingText || 'Just a moment'}</div>
        <i className="fa fa-spinner fa-spin fa-3x fa-fw"/>
      </div>
    </div>
  );
};